import styled from "styled-components"
import SecondaryButton from "components/Ui/Buttons/SecondaryButton"

export const SecureDelete = styled.div`
  border-radius: 0.5rem;

  p {
    margin: 0;
  }

  div {
    padding: 0 0 1rem 0;
  }
`

export const InputWrapper = styled.div`
  display: flex;
  margin-top: 1rem;
  position: relative;

  input {
    padding-left: 4.5rem;
  }

  svg {
    width: 1.8rem;
    height: 1.8rem;
    position: absolute;
    z-index: 1;
    top: 1.3rem;
    left: 1.5rem;
  }
`

export const StyledSecondaryButton = styled(SecondaryButton)`
  font-size: 1.1rem;
`

export const OrderList = styled.div`
  margin-top: 1rem;
  max-height: 20rem;
  overflow-y: auto;
  border: 0.1rem solid ${(p) => p.theme.colors.borderLight};
  border-radius: 0.4rem;
  padding: 1rem;
  background: ${(p) => p.theme.colors.greyLightest};

  p {
    margin: 0.5rem 0;
    font-size: 1.2rem;
  }
`
